import { defineStore } from "pinia";
import _ from "lodash";
import * as storeHelper from "@/shared/storeHelper";
import { FetchState, UserPersonalInfoState } from "@/shared/types";
import { getUserPersonalInfo } from "@/shared/api/userService";

export const initialState: UserPersonalInfoState = {
  fetchState: FetchState.Uninitialized,
  personalInfo: {
    ssn: ""
  }
};

export const useUserPersonalInfoStore = defineStore("userPersonalInfo", {
  state: () => (_.cloneDeep(initialState)),
  actions: {
    getInfo () {
      if (this.fetchState !== FetchState.Uninitialized) {
        return;
      }

      this.fetchState = FetchState.Loading;

      getUserPersonalInfo()
        .then(response => {
          this.personalInfo = response.data;
          this.fetchState = FetchState.Loaded;
        })
        .catch(error => {
          this.fetchState = FetchState.Failed;
          return storeHelper.handleError({ error, rethrow: false });
        });
    }
  }
});
